<template>
  <div class="call_reason_page">
    <h1>通话挂断原因</h1>
    <div class="user-options clearfix">
      <el-select
        style="width: 80px"
        v-model="curChannel.selectValue"
        placeholder=""
      >
        <el-option
          v-for="(item, itemIndex) in channels"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        style="width: 80px"
        v-model="curFromType.selectValue"
        placeholder=""
      >
        <el-option label="全部" value="-1"></el-option>
        <el-option label="用户主动拨打" value="1"></el-option>
        <el-option label="主播匹配拨打" value="2"></el-option>
        <el-option label="主播主动拨打" value="3"></el-option>
        <el-option label="用户匹配主播" value="4"></el-option>
        <el-option label="用户匹配用户" value="5"></el-option>
        <el-option label="用户live模式拨打" value="11"></el-option>
      </el-select>
      <el-select
        style="width: 80px"
        v-model="hostChannel.selectValue"
        placeholder=""
      >
        <el-option
          v-for="(item, itemIndex) in hostChannels"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-date-picker
        v-model="dateValue"
        value-format="yyyy-MM-dd"
        disabledDate="disabledDate"
        type="date"
        :picker-options="pickerOptions"
        placeholder="选择日期"
      >
      </el-date-picker>
      <el-button type="primary" @click="doInquery">查询</el-button>
    </div>
    <div class="display-type">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="请求失败" name="table1" class="table-container">
          <div v-loading="loading">
            <CustomTable
              :tableList="tableList1"
              :options="tableOptions"
              class="table"
            ></CustomTable>
          </div>
        </el-tab-pane>
        <el-tab-pane label="未开始" name="table2" class="table-container">
          <div v-loading="loading">
            <CustomTable
              :tableList="tableList2"
              :options="tableOptions"
              class="table"
            ></CustomTable>
          </div>
        </el-tab-pane>
        <el-tab-pane label="未扣费" name="table3" class="table-container">
          <div v-loading="loading">
            <CustomTable
              :tableList="tableList3"
              :options="tableOptions"
              class="table"
            ></CustomTable>
          </div>
        </el-tab-pane>
        <el-tab-pane label="扣费" name="table4" class="table-container">
          <div v-loading="loading">
            <CustomTable
              :tableList="tableList4"
              :options="tableOptions"
              class="table"
            ></CustomTable>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import CustomTable from '../../components/CustomTable'

export default {
  components: {
    CustomTable
  },
  data() {
    return {
      curFromType: {
        selectValue: '-1'
      },
      curChannel: {
        selectValue: 'all',
        content: ''
      },
      channels: this.$store.state.channels,
      hostChannel: {
        selectValue: 'all',
        content: ''
      },
      hostChannels: this.$store.getters.hostChannels,
      dateValue: this.$store.getters.dateOneDayBefore,
      pickerOptions: {
        disabledDate(date) {
          let dateNow = new Date()
          dateNow.setDate(dateNow.getDate() - 1)
          if (date.getTime() > dateNow.getTime()) {
            return true
          }
        }
      },
      tableOptions: {
        defaultSort: {
          prop: 'count',
          order: 'descending'
        },
        theader: [
          {
            name: 'reason',
            label: '原因',
            sortable: true,
            fix: true,
            width: '160px'
          },
          {
            name: 'name',
            label: '描述',
            sortable: true,
            fix: true,
            width: '220px'
          },
          {
            name: 'count',
            label: '数量',
            sortable: true,
            fix: true,
            width: '160px'
          },
          {
            name: 'userCount',
            label: '人数',
            sortable: true,
            fix: true,
            width: '160px'
          }
        ]
      },
      datePicked: [
        this.$store.getters.dateOneWeekBefore,
        this.$store.getters.dateOneDayBefore
      ],
      activeName: 'table1',
      tableList1: [],
      tableList2: [],
      tableList3: [],
      tableList4: [],
      loading: true
    }
  },
  beforeCreate() {},
  created() {
    this.getList()
  },
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username
    },
    userLevel() {
      return this.$store.getters.userLevel
    },
    token() {
      return this.$store.getters.token
    }
  },
  watch: {},
  methods: {
    datePickedChange(date) {
      this.datePicked = date
    },
    //获取视频通话数据
    getList() {
      this.loading = true
      this.$axios({
        type: 'GET',
        url: this.$store.getters.path.stats_query_call_reasons,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token,
          start: this.dateValue,
          channel: this.curChannel.selectValue,
          from_type: this.curFromType.selectValue,
          to_channel: this.hostChannel.selectValue
        }
      })
        .then(
          res => {
            if (res.data.code === 0) {
              this.tableListBuild(res.data.data)
            } else if (res.data.code === 1001) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
              this.$router.push(this.$route.query.redirect || '/login')
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
            }
          },
          err => {
            this.$message({
              showClose: true,
              message: '请求错误:' + err,
              type: 'error'
            })
          }
        )
        .then(() => {
          this.loading = false
        })
    },
    //表格数据
    tableListBuild(data) {
      this.tableList1 = data.requestFailList
      this.tableList2 = data.callFailList
      this.tableList3 = data.noFeeList
      this.tableList4 = data.feeList
    },
    doInquery() {
      this.getList()
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.call_reason_page {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;

    .bar-container {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;

      .bar {
        margin-left: 10px;
        display: inline-block;
        width: 900px;
        height: 300px;
      }
    }
  }
}
</style>
